import LandingPage from "./LandingPage";
import { lawFirmsContent } from "./content/law-firms";

export default function LawFirmsPage() {
  return <LandingPage content={lawFirmsContent} />;
}
